/**
 * Where the API client gets a Privy access token. AuthProvider registers Privy's getAccessToken once the provider is
 * mounted; tests register a stub. Only POST /api/media, /api/metadata, /api/tx/launch and the identity link routes
 * send the token (a token on a cross-origin GET would cost a CORS preflight per URL).
 */

type TokenSource = () => Promise<string | null>;

let source: TokenSource = async () => null;
let anonymous = false;

export function setTokenSource(fn: TokenSource): void {
  source = fn;
}

/** The local clone runs the server with RAYDIUS_AUTH=optional: let signed-out requests through there (dev wallet). */
export function setAnonymousAuth(allowed: boolean): void {
  anonymous = allowed;
}

export const anonymousAuthAllowed = () => anonymous;

/** null when signed out. Privy refreshes an expired token itself. */
export async function getAccessToken(): Promise<string | null> {
  try {
    return await source();
  } catch {
    return null;
  }
}
